<template>
  <div class="labeling" @keydown.ctrl.83.prevent.stop="handleSave" @keydown.meta.83.prevent.stop="handleSave">
    <div ref="label3DModel" class="labeling__container-left">
      <div ref="label3DModelContainer" class="canvas"/>
    </div>
    <div ref="labelSingle" class="labeling__container-right">
      <div ref="labelSingleContainer" class="canvas"/>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';
import { bulkCreatePoint, deletePoint } from '@/api/deployment';
import { uuid } from '@/utils/index';
import WorkbenchStore from './store';
import WorkbenchAssembly from './assembly';
import eventHub from '@/utils/eventHub';
import { events } from '@/utils/events';

export default {
  data() {
    return {
      oldDeviceUUID: null,
      oldFloorId: null,
      floorInfo: null,
      place_id: this.$route.query.place_id,
      project_id: this.$route.query.project_id,
      loading: false,
      assembly: null,
      store: null,
      intervalID: null,
    };
  },
  computed: {
    ...mapGetters(['sidebar']),
  },
  watch: {
    sidebar: {
      handler(newVal, oldVal) {
        this.destoryStage(true);
        setTimeout(() => {
          // 给flex留下调整的时间
          this.initStage();
          this.assembly.selectCamera(this.oldDeviceUUID);
        }, 1000);
      },
      deep: true,
    },
  },
  created() {
    eventHub.$on(events.DEVICE_TYPE_CHECKED, this.eventDeviceTypeChecked);
    eventHub.$on(events.FLOOR_CHECKED, this.eventFloorChecked);
    eventHub.$on(events.DEVICE_CHECKED, this.eventDeviceChecked);
    eventHub.$on(events.REMOVE_DEVICE, this.eventRemoveDevice);
  },
  mounted() {
    document.addEventListener('keydown', this.handleSave);
  },
  methods: {
    eventDeviceTypeChecked(device) {
      this.addDevice(device);
    },
    eventFloorChecked(floor) {
      this.setFloor(floor);
    },
    eventDeviceChecked(uuid) {
      this.deviceSelected(uuid);
    },
    eventRemoveDevice(uuid) {
      this.deleteDevicePoints(uuid);
    },
    setFloor(floorInfo) {
      if (floorInfo.floor_id === this.oldFloorId) {
        return;
      }
      this.floorInfo = floorInfo;
      this.oldFloorId = floorInfo.floor_id;
      this.destoryStage();
      this.initStage();
    },
    destoryStage(isSaveDeviceChecked = false) {
      if (this.assembly && this.assembly.stage) {
        this.assembly.stage.dispose();
        this.assembly.removeEvent();
        // 清除选中设备
        if (!isSaveDeviceChecked) {
          eventHub.$emit(events.CANCEL_DEVICE_CHECKED);
        }
        this.assembly = null;
      }
    },
    initStage() {
      const { floorInfo } = this;
      const { device_list: deviceList, mesh_id: meshId } = floorInfo;
      const { label3DModelContainer, labelSingleContainer } = this.$refs;
      this.assembly = new WorkbenchAssembly(label3DModelContainer, labelSingleContainer, meshId);
      const formatDeviceList = deviceList.map((device) => {
        const { x, y, z, rw, rx, ry, rz, point_uuid: uuid } = device;
        return { x, y, z, rw, rx, ry, rz, uuid };
      });
      this.store = new WorkbenchStore(this.assembly.stage, formatDeviceList);
      this.renderDevices(formatDeviceList);
      this.assembly.initEvent((type, data, uuid) => {
        if (type === 'select') {
          eventHub.$emit(events.DEVICE_CHECKED, uuid);
        } else {
          if (type === 'position') {
            eventHub.$emit(events.CANCEL_DEVICE_TYPE_CHECKED);
          }
          this.store.collectPositionORPoseActions(uuid);
          if (!this.store.isPhaseActionsEmpty()) {
            // 有效操作才保存，点击事件除外
            this.autoSave();
          }
        }
      });
    },
    renderDevices(deviceList) {
      deviceList.forEach((device) => {
        const { x, y, z, rw, rx, ry, rz, uuid } = device;
        this.assembly.addCamera(uuid, { x, y, z, rw, rx, ry, rz });
      });
    },
    resetDeploy() {
      // 解绑即将要添加的摄像头
      this.assembly.cancelAddCamera();
    },
    addDevice(device) {
      this.resetDeploy();
      if (!device) {
        return;
      }
      this.$notify({
        message: `请在模型中放置${device.label}`,
        duration: 2000,
      });
      if (device.value === 1) {
        // 添加摄像头
        this.assembly.addCamera();
      }
    },
    deviceSelected(uuid) {
      if (uuid === this.oldDeviceUUID) {
        return;
      }
      this.oldDeviceUUID = uuid;
      this.assembly.selectCamera(uuid);
    },
    handleSave(e) {
      // ctrl + s 或者 meta + s 触发手动保存
      if (!((e.keyCode === 83 && e.ctrlKey) || (e.keyCode === 83 && e.metaKey))) {
        return;
      }
      e.preventDefault();
      if (this.intervalID) {
        clearInterval(this.intervalID);
        this.intervalID = null;
      }
      if (this.store.isPhaseActionsEmpty() && this.store.isPoolActionsEmpty()) {
        this.emitWords('所有更改已保存');
        return;
      }
      this.emitWords('保存中...');
      const devicePoolActions = this.store.getPhaseActions();
      this.prePostDevices(devicePoolActions);
    },
    autoSave() {
      this.emitWords('待自动保存（或者 ctrl + s 直接保存）');
      if (this.intervalID) {
        return;
      }
      this.intervalID = setInterval(() => {
        if (this.store.isPhaseActionsEmpty() && this.store.isPoolActionsEmpty()) {
          // 所有更改已保存
          this.emitWords('所有更改已保存');
          clearInterval(this.intervalID);
          this.intervalID = null;
          return;
        }
        this.emitWords('保存中...');
        const devicePoolActions = this.store.getPhaseActions();
        this.prePostDevices(devicePoolActions);
      }, 5000);
    },
    prePostDevices(devicePoolActions) {
      if (!devicePoolActions) {
        return; // is locked
      }
      const { floorInfo, place_id, project_id } = this;
      const { floor_name: floor, floor_id } = floorInfo; // 需要跟迁迁确认一下这个字段
      const prePostData = Object.entries(devicePoolActions).map(([uuid, data]) => ({
        name: '未命名',
        floor,
        floor_id,
        point_uuid: uuid,
        place_id,
        project_id,
        point_type: 1, // 后期还需要维护类型
        action: this.store.isDeviceInDatabase(uuid) ? 'update' : 'insert',
        ...data,
      }));
      this.postDevicePoints(prePostData);
    },
    postDevicePoints(params) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      bulkCreatePoint(params).then(() => {
        this.loading = false;
        // this.$message.success('自动保存成功');
        this.store.synchronizeDatabase(true);
        // 更新左侧设备列表
        eventHub.$emit(events.REFRESH_DEVICE_LIST);
        if (this.store.isPhaseActionsEmpty() && this.store.isPoolActionsEmpty()) {
          this.emitWords('所有更改已保存');
        }
      }).catch((e) => {
        this.loading = false;
        this.synchronizeDatabase(false);
        // this.$message.warning('自动保存失败，下次一起保存');
      });
    },
    deleteDevicePoints(uuid) {
      deletePoint({ point_uuid: uuid }).then(() => {
        eventHub.$emit(events.REFRESH_DEVICE_LIST);
        this.assembly.deleteCamera(uuid);
        this.$message.success('摄像头删除成功');
      }).catch((err) => {
        this.$message.error(err);
      });
    },
    emitWords(words) {
      eventHub.$emit(events.AUTO_SAVE_WORDS, words);
    },
  },
  beforeDestroy() {
    // 清除已选楼层
    document.removeEventListener('keydown', this.handleSave);
    this.destoryStage();
    eventHub.$emit(events.CANCEL_FLOOR_CHECKED);
    eventHub.$off(events.DEVICE_TYPE_CHECKED, this.eventDeviceTypeChecked);
    eventHub.$off(events.FLOOR_CHECKED, this.eventFloorChecked);
    eventHub.$off(events.DEVICE_CHECKED, this.eventDeviceChecked);
    eventHub.$off(events.REMOVE_DEVICE, this.eventRemoveDevice);
  },
};
</script>
<style lang="less" scoped>
.labeling {
  height: 100%;
  display: flex;
  &__container {
    &-left {
      flex: 1;
      margin-right: 10px;
      border-radius: 10px;
      overflow: hidden;
    }
    &-right {
      flex: 1;
      border-radius: 10px;
      overflow: hidden;
    }
  }
  .canvas {
    height: 100%;
  }
}
</style>
